import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@env/environment';
import { EmbedToken } from '@power-bi/models/embed-token';

@Injectable()
export class PowerBIEmbedService {
  readonly #httpClient = inject(HttpClient);
  readonly #coreApiUrl = `${ENVIRONMENT.coreApi.endpoint}/powerbi/embed`;

  getEmbedToken(clientPowerBIReportId: string): Observable<EmbedToken> {
    return this.#httpClient.get<EmbedToken>(
      `${this.#coreApiUrl}/token/${clientPowerBIReportId}`
    );
  }
}
